import React from "react";
import { Avatar } from "antd";
import { Link } from "react-router-dom";

const AdvisorCard = ({
  firstName,
  lastName,
  sebiRegistrationNumber,
  successRate,
  accuracy,
  roi,
  userId,
  experience,
  isSubscribed,
}) => {
  return (
    <div className="bg-white border-b border-[#D9D9D9] p-4 lg:p-5 hover:shadow-md transition-shadow duration-200">
      <div className="flex flex-col xl:flex-row xl:items-center gap-4 xl:gap-6">
        <div className="flex items-center gap-3 lg:gap-4 flex-shrink-0">
          <Avatar
            size={{ xs: 56, sm: 56, md: 64, lg: 64, xl: 64, xxl: 64 }}
            src="https://media.istockphoto.com/id/1476170969/photo/portrait-of-young-man-ready-for-job-business-concept.webp?b=1&s=612x612&w=0&k=20&c=A87DXDjXjoyJWkWIlLfhJYsjqKtTyuvhOg14QY4SeMQ="
            className="flex-shrink-0"
          />
          <div className="min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="text-base lg:text-lg font-bold text-[#454545] truncate font-inter">
                {firstName} {lastName}
              </h3>
            </div>
            <p className="text-xs lg:text-sm text-[#939393] font-roboto">
              SEBI Registration no:{" "}
              <span className="text-[#939393] font-roboto">
                {sebiRegistrationNumber}
              </span>
            </p>
          </div>
        </div>

        <div className="flex flex-1 justify-around xl:justify-start gap-4 lg:gap-6 xl:gap-12 flex-wrap sm:flex-nowrap">
          <div className="text-center lg:text-left min-w-fit">
            <p className="text-lg lg:text-xl font-semibold text-[#1a1a1a] mb-0.5">
              {successRate}%
            </p>
            <p className="text-xs lg:text-sm text-gray-500">Success rate</p>
          </div>
          <div className="text-center lg:text-left min-w-fit">
            <p className="text-lg lg:text-xl font-semibold text-[#454545] mb-0.5">
              {accuracy}%
            </p>
            <p className="text-xs lg:text-sm text-gray-500">Accuracy</p>
          </div>
          <div className="text-center lg:text-left min-w-fit">
            <p className="text-lg lg:text-xl font-semibold text-[#454545] mb-0.5">
              {roi}%
            </p>
            <p className="text-xs lg:text-sm text-gray-500">ROI</p>
          </div>
          <div className="text-center lg:text-left min-w-fit">
            <p className="text-lg lg:text-xl font-semibold text-[#454545] mb-0.5">
              {experience}+ years
            </p>
            <p className="text-xs lg:text-sm text-gray-500">Experience</p>
          </div>
        </div>

        <div className="flex-shrink-0">
          <Link to={`/advisor/${userId}`} className="block">
            <button className="w-full xl:w-auto px-6 lg:px-8 py-2.5 lg:py-3 bg-primary hover:bg-primary/80 text-white text-sm lg:text-base font-medium rounded-lg transition-colors duration-200 font-roboto font-normal">
              View Profile
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdvisorCard;
